<!-- 联调工具 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">联调工具</div>
	
	<div style="margin-top: 30px;display: flex;flex-wrap: wrap;">
		<div class="tool-box" v-for="item in contentData">
			<div class="tool-box-title">{{item.title}}</div>
			<div class="tool-box-text">{{item.text}}</div>
			<div @click="selectItem(item)" class="tool-box-button">联调</div>
		</div>
		
	</div>
	
	<!-- 联调 -->
	<a-modal
	      :title="`联调`"
	      :visible="edit_visible"
	      :confirm-loading="confirmLoading" 
		  width="800px" 
		  cancelText="取消"
		  okText="确认" 
	      @ok="editModalOk"
	      @cancel="editModalCancel"
	    >
			<div class="screen-box" style="margin-bottom: 17px;">
				<div class="screen-label" style="text-align: right;">联调事件：</div>
				<!-- 华为或巨量 -->
				{{modal_title}}
			</div>
			<template v-if="modal_type == 1">
				<div class="screen-box" style="align-items: flex-start;margin-bottom: 20px;">
					<div class="screen-label" style="text-align: right;">联调方式：</div>
					<a-radio-group @change="radioChangeA" name="radioGroup" :value="jl_radio_type">
						<a-radio :value="1">
						  点击监测
						</a-radio>
						<a-radio :value="2">
						  小程序
						</a-radio>
					</a-radio-group>
				</div>
				<div v-if="jl_radio_type == 1" class="screen-box" style="align-items: flex-start;">
					<div class="screen-label" style="text-align: right;">链接：</div>
					<a-textarea
						  v-model="e_url"
						  :placeholder="modal_placeholder"
						  :auto-size="{ minRows: 8, maxRows: 15 }"
						/>
				</div>
				
				<div v-if="jl_radio_type == 2" class="screen-box" style="align-items: flex-start;">
					<div class="screen-label" style="text-align: right;">小程序注册用户ID：</div>
					<a-textarea
						  v-model="e_xcx_user_id"
						  placeholder="请到小程序注册用户表复制用户ID"
						  :auto-size="{ minRows: 8, maxRows: 15 }"
						/>
				</div>
				
			</template>
			
			<template v-else-if="modal_type == 6">
				<div class="screen-box" style="align-items: flex-start;margin-bottom: 20px;">
					<div class="screen-label" style="text-align: right;">联调方式：</div>
					<a-radio-group @change="radioChangeB" name="radioGroup" :value="bd_radio_type">
						<a-radio :value="118">
						  付费观剧
						</a-radio>
					</a-radio-group>
				</div>
				<div class="screen-box" style="align-items: flex-start;margin-bottom: 20px;">
					<div class="screen-label" style="text-align: right;">链接：</div>
					<a-textarea
						  v-model="e_url"
						  :placeholder="modal_placeholder"
						  :auto-size="{ minRows: 5, maxRows: 8 }"
						/>
				</div>
				
				<div class="screen-box" style="align-items: flex-start;">
					<div class="screen-label" style="text-align: right;">token：</div>
					<a-textarea
						  v-model="e_bd_token"
						  placeholder="请填写 token"
						  :auto-size="{ minRows: 5, maxRows: 8 }"
						/>
				</div>
				
			</template>
			
			<div v-else class="screen-box" style="align-items: flex-start;">
				<div class="screen-label" style="text-align: right;">链接：</div>
				<a-textarea
					  v-model="e_url"
					  :placeholder="modal_placeholder"
					  :auto-size="{ minRows: 8, maxRows: 15 }"
					/>
			</div>
	</a-modal>
</div>
</template>

<script>
import { cdPromoteAssetsReport, linkToolKs, linkToolOppo, linkToolVivo, linkToolBd } from '@/request/api'
export default {
	name: 'linkUrl_',
	components: {
	},
	data() {
		return {
			contentData: [
				{
					title: "巨量引擎-付费事件",
					text:"请填写 巨量有效触点监测链接，完成联调",
					type: 1,
				},
				{
					title: "快手 - 激活事件",
					text:"请填写 快手点击监测链接，完成联调",
					type: 2,
				},
				{
					title: "快手 - 付费事件",
					text:"请填写 快手点击监测链接，完成联调",
					type: 3,
				},
				{
					title: "OPPO - 付费事件",
					text:"请填写 OPPO点击监测链接，完成联调",
					type: 4,
				},
				{
					title: "VIVO - 付费事件",
					text:"请填写 VIVO点击监测链接，完成联调",
					type: 5,
				},
				{
					title: "百度",
					text:"请填写 带有bd-vid的推广url",
					type: 6,
				},
			],
			// 单个编辑弹窗
			edit_visible: false, // 编辑弹窗的显示
			confirmLoading: false,
			edit_modal_title: "", // 编辑弹窗的标题
			e_id: "", // 编辑请求用的id
			e_url: "", // 巨量联调-广告点击Url
			e_xcx_user_id: null, // 小程序注册用户ID
			
			modal_title: null,
			modal_placeholder: null,
			modal_url: null,
			
			jl_radio_type: 1,
			
			modal_type: 1,
			
			bd_radio_type: 118, // 百度-付费观剧（type=118）
			e_bd_token: null,
		}
	},
	methods:{
		selectItem(item){
			this.modal_title = item.title
			this.modal_placeholder = item.text
			this.modal_type = item.type
			
			this.edit_visible = true
		},
		editModalOk(){
			let that = this
			if(!that.e_url && that.jl_radio_type == 1){
				that.$message.warning('链接不能为空');
				return
			}
			that.confirmLoading = true
			if(this.modal_type == 1){ // 巨量引擎
				if(that.jl_radio_type == 2 && !that.e_xcx_user_id){
					that.$message.warning('小程序注册用户ID 不能为空');
					return
				}
				let r_data = {
					type: 1,
				}
				if(that.jl_radio_type == 1){
					r_data.url = that.e_url
				}
				else if(that.jl_radio_type == 2){
					r_data.user_id = that.e_xcx_user_id
					r_data.user_type = 2
				}
				cdPromoteAssetsReport(r_data).then(res=>{
					that.confirmLoading = false
					console.log("巨量引擎",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('联调成功');
						that.editModalCancel()
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			else if(this.modal_type == 2 || this.modal_type == 3){ // 快手
				let ttt = 1
				if(this.modal_type == 2){ // 快手 - 激活事件
					ttt = 1
				}
				else if(this.modal_type == 3){ // 快手 - 付费事件
					ttt = 2
				}
				linkToolKs({
					type: ttt, // type =1 联调激活，=2联调付费
					url: that.e_url,
				}).then(res=>{
					that.confirmLoading = false
					console.log("快手 - 激活事件",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('联调成功');
						that.editModalCancel()
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			else if(this.modal_type == 4){ // OPPO - 付费事件
				linkToolOppo({
					url: that.e_url,
				}).then(res=>{
					that.confirmLoading = false
					console.log("OPPO - 付费事件",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('联调成功');
						that.editModalCancel()
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			else if(this.modal_type == 5){ // VIVO - 付费事件
				linkToolVivo({
					url: that.e_url,
				}).then(res=>{
					that.confirmLoading = false
					console.log("VIVO - 付费事件",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('联调成功');
						that.editModalCancel()
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			else if(this.modal_type == 6){ // 百度
				linkToolBd({
					url: that.e_url,
					token: that.e_bd_token,
					type: 118, // 联调的类型 188=短剧付费
				}).then(res=>{
					that.confirmLoading = false
					console.log("百度",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('联调成功');
						that.editModalCancel()
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
		},
		editModalCancel(){
			this.edit_visible = false
			
			this.e_url = null
			this.confirmLoading = false
			
			this.jl_radio_type = 1
			this.e_xcx_user_id = null
		},
		
		radioChangeA(e){
			console.log(e.target.value);
			this.jl_radio_type = e.target.value
		},
		radioChangeB(e){
			
		},
	}
}
</script>

<style scoped>
.tool-box {
	padding: 30px;
	border: 1px solid #eee;
	border-radius: 4px;
	margin-right: 30px;
	margin-bottom: 30px;
	width: 320px;
}
.tool-box-title {
	font-size: 14px;
	font-weight: 600;
}
.tool-box-text {
	color: #86909C;
	margin: 14px 0 17px;
	font-size: 12px;
}
.tool-box-button {
	width: 88px;
	height: 32px;
	line-height: 32px;
	text-align: center;
	color: #165DFF;
	border: 1px solid #165DFF;
	border-radius: 4px;
	cursor: pointer;
}

.screen-label {
	width: 126px;
}
</style>